import React from 'react';
import { Link } from 'react-router-dom';
import './BackButton.css';

const BackButton = ({ to = null, onClick = null, label = '← Retour aux destinations' }) => {
  const content = to ? (
    <Link to={to} className="back-btn btn btn-secondary">{label}</Link>
  ) : (
    <button type="button" onClick={onClick} className="back-btn btn btn-secondary">{label}</button>
  );

  return (
    <div className="page-back-container">
      {content}
    </div>
  );
};

export default BackButton;
